import { useMemo, useEffect, useRef, useState } from 'react'
import API from 'api'
import Pagination from 'react-js-pagination'
import PlaceholderTrip from './PlaceholderTrip'
import GroupTripCard from './GroupTripCard'
import get from 'lodash/get'
import { paginationHook } from '../search/hooks'
import { NoSearchResults } from '../search'

const PAGE_SIZE = 10

const Loader = () => {
  return useMemo(
    () =>
      [...new Array(10)].map((_, i) => {
        return <PlaceholderTrip key={i} />
      }),
    []
  )
}

let controller, signal

export default function TripItem({
  model,
  pk,
  selectedParams,
  setNumberOfItems,
}) {
  const { page, setPage } = paginationHook()
  const [isLoading, setLoading] = useState(true)
  const [shops, setShops] = useState([])
  const [numberOfTrips, setNumberOfTrips] = useState(0)
  const tripContainerRef = useRef()

  useEffect(() => {
    getTrips(page)
    return () => controller && controller.abort()
  }, [selectedParams, page])

  const getTrips = (currentPage) => {
    if('AbortController' in window) {
      controller = new window.AbortController()
      signal = controller.signal
    }

    setLoading(true)
    return API(`search/${model.toLowerCase()}/${pk}/group-trips/`, signal)
      .get({
        ...selectedParams,
        page: currentPage || page,
        page_size: PAGE_SIZE,
      })
      .then((data) => {
        const shops = data.results

        setNumberOfItems(data.count, 'numberOfTrips')
        setShops(shops)
        setNumberOfTrips(data.count)
        setLoading(false)
      })
      .catch((error) => {
        if(
          window.DOMException &&
          error.code === window.DOMException.ABORT_ERR
        ) {
          console.warn('Request canceled.')
        } else if(
          error.status === 404 &&
          get(error, 'error.detail') === 'Invalid page.'
        ) {
          onPageChange(1)
        } else {
          setShops([])
          setNumberOfTrips(0)
          setLoading(false)
        }
      })
  }

  const onPageChange = (page) => {
    if(tripContainerRef.current) {
      window.scrollTo(0, tripContainerRef.current.offsetTop)
    }
    setPage(page)
  }

  if(isLoading) {
    return <Loader />
  }

  return (
    <div ref={tripContainerRef} className='results'>
      {!shops.length && <NoSearchResults />}
      {shops.map((trip) => {
        return <GroupTripCard trip={trip} key={trip.url} />
      })}
      {numberOfTrips > PAGE_SIZE && (
        <div className='pagination-wrap'>
          <Pagination
            activePage={page}
            innerClass='custom-pagination'
            itemsCountPerPage={PAGE_SIZE}
            itemClassPrev='prev'
            itemClassNext='next'
            prevPageText=''
            nextPageText=''
            itemClassFirst='hidden'
            itemClassLast='hidden'
            totalItemsCount={numberOfTrips}
            pageRangeDisplayed={5}
            onChange={onPageChange}
          />
        </div>
      )}
    </div>
  )
}
